import React from 'react';
import { useTranslate } from 'react-admin';
import { computeEventStatus } from '../../utils/eventStatus';

/**
 * DataGrid Status kolonu — computeEventStatus ile tek mantik + i18n etiket.
 */
const EventStatusCell = ({ event, endedLabel }) => {
  const translate = useTranslate();
  const status = computeEventStatus(event);
  const label =
    endedLabel && status.key === 'ended'
      ? endedLabel
      : translate(`event_status.${status.key}`, { _: status.label });

  return (
    <div
      style={{
        backgroundColor: status.bgColor,
        color: status.color,
        textAlign: 'center',
        borderRadius: 5,
        padding: '3px 6px',
        width: '100%',
      }}
    >
      <span>{label}</span>
    </div>
  );
};

export default EventStatusCell;
